const REGISTER_ERROR = 'REGISTER_ERROR';
const CLEAR_ERROR = 'CLEAR_ERROR';

const init = { status: null, message: null };

export default function(state = init, action = {}) {
  switch (action.type) {
    case REGISTER_ERROR:
      return { status: action.error.status, message: action.error.message };
    case CLEAR_ERROR:
      return init;
    default:
      return state;
  }
}

export function clearError() {
  return dispatch => dispatch({ type: CLEAR_ERROR });
}

export function registerError(error = {}) {
  return dispatch => dispatch({ type: REGISTER_ERROR, error });
}
